export default __webpack_public_path__ + "static/media/peep-34.05a86820.svg";